import { render, staticRenderFns } from "./FormSearchBar.vue?vue&type=template&id=52dab476&"
import script from "./FormSearchBar.vue?vue&type=script&lang=js&"
export * from "./FormSearchBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FormSearchBar.vue"
export default component.exports